import styled from 'styled-components';
import { Table as TableAntd } from 'antd';
import { vars, getBreakpoint } from '$util/theme';
import { Button } from '@/components/atoms/Button';
import Grid from '$components/layout/Grid';

const { Col } = Grid;

export const StyledCol = styled(Col)`
  width: 100%;
  margin-bottom: 20px;
  @media (min-width: ${getBreakpoint('md')}) {
    width: 17vw;
  }
  @media (min-width: ${getBreakpoint('lg')}) {
    width: 15vw;
  }
  .card-1 {
    padding: 0;
    border-radius: 24px 8px 8px 7px;
    @media (min-width: ${getBreakpoint('md')}) {
      border-radius: 8px;
    }
    .up {
      position: relative;
      height: 90px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-size: cover;
      background-position: center center;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .img-div {
        height: 88px;
        width: 88px;
        margin: -10px 0 0 -10px;
        img {
          height: 88px;
          border-radius: 50%;
        }
      }
      @media (min-width: ${getBreakpoint('md')}) {
        height: 160px;
        img {
          height: 100%;
          width: 100%;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          margin-top: 0;
          margin-left: 0;
        }
      }
    }
    .down {
      display: flex;
      flex-direction: column;
      height: 90px;
      padding: 20px 10px;
      @media (min-width: ${getBreakpoint('md')}) {
        padding: 20px 5px;
        height: 240px;
      }
      @media (min-width: ${getBreakpoint('lg')}) {
        padding: 10px;
        height: 240px;
      }
      @media (min-width: ${getBreakpoint('xl')}) {
        height: 200px;
      }
      &.down-minute {
        height: 120px;
        @media (min-width: ${getBreakpoint('md')}) {
          height: 340px;
        }
        @media (min-width: ${getBreakpoint('lg')}) {
          height: 250px;
        }
      }
      .team,
      .car-minute {
        border-bottom: 1px solid #ecf2f4;
        padding-bottom: 5px;
      }
      .car,
      .value-minute {
        padding-top: 5px;
      }
      .team {
        @media (min-width: ${getBreakpoint('md')}) {
          word-break: break-word;
        }
      }
      .team,
      .car,
      .value-minute {
        display: flex;
        @media (min-width: ${getBreakpoint('md')}) {
          align-items: center;
        }
        p {
          color: #020202;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 0;
          &:first-child {
            width: 30%;
            padding-left: 10px;
          }
          &:nth-child(2) {
            font-size: 14px;
            font-weight: bold;
          }
          @media (min-width: ${getBreakpoint('md')}) {
            &:first-child {
              font-size: 12px;
              padding-left: 5px;
            }
            &:nth-child(2) {
              width: 70%;
              font-size: 13px;
              padding-left: 10px;
            }
          }
          @media (min-width: ${getBreakpoint('xl')}) {
            &:first-child {
              font-size: 13px;
              padding-left: 10px;
            }
            &:nth-child(2) {
              font-size: 14px;
            }
          }
        }
      }
    }
    .name-div {
      display: flex;
      align-items: center;
      height: 50%;
      width: 70%;
      @media (min-width: ${getBreakpoint('md')}) {
        width: unset;
        margin-bottom: 10px;
      }
      > span {
        font-size: 53px;
        font-weight: bold;
        color: #ddf1f7;
        @media (min-width: ${getBreakpoint('md')}) {
          font-size: 32px;
        }
        @media (min-width: ${getBreakpoint('xl')}) {
          font-size: 53px;
        }
      }
      > div {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        .name {
          font-size: 20px;
          font-weight: bold;
          color: ${vars.quantumverse.reskinColors.purple500};
          margin-bottom: 0;
          line-height: 1.2;

          @media (min-width: ${getBreakpoint('md')}) {
            font-size: 16px;
            word-break: break-word;
          }
          @media (min-width: ${getBreakpoint('xl')}) {
            font-size: 20px;
          }
        }
        .minute {
          font-size: 14px;
          font-weight: bold;
          color: #020202;
          margin-bottom: 0;
          @media (min-width: ${getBreakpoint('lg')}) {
            font-size: 17px;
          }
        }
        .value {
          font-size: 17px;
          font-weight: bold;
          color: #020202;
          margin-bottom: 0;
          @media (min-width: ${getBreakpoint('md')}) {
            word-break: break-word;
          }
        }
      }
    }
    .lower-div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
`;

export const Div = styled.div``;

export const Table = styled(TableAntd)`
  table {
    border-radius: 4px;
    border: solid 1px #d4e5f9;
    display: block;
    overflow: scroll;
    thead > tr > th {
      background-color: #eff5fc;
      padding-left: 5px;
      padding-right: 5px;
      text-align: center;
      @media (min-width: ${getBreakpoint('xl')}) {
        &:first-child {
          width: 5%;
        }
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(11) {
          width: 10%;
        }
        &:nth-child(10) {
          width: 12%;
        }
      }
      .ant-table-column-sorters {
        display: flex;
        align-items: center;
        .ant-table-column-title {
          color: ${vars.quantumverse.reskinColors.purple500};
          font-size: 11.5px;
          font-weight: 600;
          display: flex !important;
          align-items: center;
          p {
            margin-bottom: 0;
            margin-right: 4px;
            &.long {
              @media (min-width: ${getBreakpoint('md')}) {
                width: 85%;
              }
            }
          }
        }
      }
      .ant-table-column-sorter {
        .ant-table-column-sorter-inner {
          margin-top: 0;
        }
      }
    }
    tbody > tr > td {
      font-size: 12px;
      text-align: center;
      &:first-child {
        font-weight: 600;
        color: ${vars.quantumverse.reskinColors.purple500};
        text-align: center;
      }
      &.ant-table-column-has-actions {
        color: #818182;
        padding-left: 5px;
        padding-right: 5px;
      }
    }
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: ${vars.quantumverse.reskinColors.white};
      @media (min-width: ${getBreakpoint('lg')}) {
        background: #e6f7ff;
      }
    }
  }
`;

export const ButtonStyled = styled(Button)`
  font-size: 14px;
  font-weight: 600;
  width: 248px;
  height: 45px;
  border-radius: 29px;
  margin: 40px auto 0;
  @media (min-width: ${getBreakpoint('md')}) {
    font-size: 16px;
    width: 308px;
    height: 56px;
  }
`;
